import React, { ReactNode } from "react"
import {
  Box, Divider, Flex, Text,
} from "@chakra-ui/react"

export const EditorPaneTitle = ({ children }: { children: ReactNode }) => (
  <Text as="h3" fontWeight="bold" textColor="gray.600" textTransform="uppercase" fontSize="xs" py={2} px={4}>
    {children}
  </Text>
)

export const EditorPaneContent = ({ children }: { children: ReactNode }) => (
  <>
    <Box px={4}>
      <Divider />
    </Box>
    <Flex gap={2} flexDirection="column" py={4} px={4}>
      {children}
    </Flex>
  </>
)

type Props = {
  title?: string
  children: ReactNode
}

/** A group of controls in a side panel: an optional title, then its content. */
const EditorPane = ({ title, children }: Props) => (
  <Box flexGrow={0} textAlign="left">
    {title && <EditorPaneTitle>{title}</EditorPaneTitle>}
    <EditorPaneContent>{children}</EditorPaneContent>
  </Box>
)

export default EditorPane
